import mixin from './mixin';
import SourceSet from './components/SourceSet.vue';
import StoryFilter from './components/StoryFilter.vue';

const storyOverviewApp = {
	components: { SourceSet, StoryFilter },
	mixins: [mixin],
	data() {
		return {
			dataJson: null,
			stories: [],
			dataGroups: [],
			filterGroups: [],
			showModal: false,

			dataGrouplabel: '',
		};
	},
	computed: {
		filteredItems() {
			if (!this.stories) return [];
			if (!this.filterGroups.length) return this.stories;
			return this.stories.filter((story) => this.filterOnGroup(story));
		},
		groups() {
			if (!this.dataGroups || !this.stories || !this.stories.length) return [];
			return this.dataGroups.filter(doelgroep => {
				return this.stories.some(item => item.Doelgroep === doelgroep.Naam) ||
					doelgroep.Subdoelgroepen.some(subdoelgroep => this.stories.some(item => item.Doelgroep === subdoelgroep.Naam))
			});
		},
	},
	methods: {
		filterOnGroup(story) {
			return this.filterGroups.includes(story.Doelgroep);
		},
		onFilterGroup(groupName) {
			let newFilterGroups = [...this.filterGroups];
			let group = this.groups.find((g) => g.Naam === groupName);
			if (group) {
				let subGroups = group.Subdoelgroepen.map((subGroup) => subGroup.Naam);
				if (newFilterGroups.includes(groupName)) {
					newFilterGroups = newFilterGroups.filter(
						(name) => name !== groupName && !subGroups.includes(name)
					);
				} else {
					newFilterGroups.push(groupName);
					subGroups.forEach((subGroupName) =>
						newFilterGroups.push(subGroupName)
					);
				}
			} else {
				const index = newFilterGroups.indexOf(groupName);
				if (index > -1) {
					newFilterGroups.splice(index, 1);
				} else {
					newFilterGroups.push(groupName);
				}
			}
			this.filterGroups = newFilterGroups;
			const url = new URL(location);
			if (this.filterGroups.length) {
				url.searchParams.set('groups', this.filterGroups.join('+'));
			} else {
				url.searchParams.delete('groups');
			}
			history.pushState({}, '', url);
		},
		openModal() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
	},
	created() {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		if (urlParams.has('groups')) {
			this.filterGroups = urlParams.get('groups').split('+');
		}
	},
	mounted() {
		if (this.$el.dataset.json) this.dataJson = JSON.parse(this.$el.dataset.json);
		if (this.dataJson.SubPages) this.stories = this.dataJson.SubPages;
		if (this.dataJson.Doelgroepen) this.dataGroups = this.dataJson.Doelgroepen;
		if (this.$el.dataset.grouplabel) this.dataGrouplabel = this.$el.dataset.grouplabel;
	},
};

export default storyOverviewApp;
